import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loadButton"]
  static values = { 
    threshold: { type: Number, default: 200 },
    autoLoad: { type: Boolean, default: true }
  }

  connect() {
    console.log('🚀 Rails 8 Turbo Infinite Scroll connected')
    
    if (this.autoLoadValue) {
      this.startObserving()
    }
  }

  disconnect() {
    this.stopObserving()
  }

  startObserving() {
    if (!this.hasLoadButtonTarget) return
    
    // Create intersection observer to detect when load button comes into view
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log('📍 Load button visible, auto-loading more posts')
          this.loadMore()
        }
      })
    }, {
      rootMargin: `${this.thresholdValue}px`,
      threshold: 0.1
    })
    
    this.observer.observe(this.loadButtonTarget)
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  loadMore() {
    if (!this.hasLoadButtonTarget) return
    
    const button = this.loadButtonTarget.querySelector('a')
    if (!button) return
    
    // Show loading state
    this.showLoadingState()
    
    // Stop observing while loading
    this.stopObserving()
    
    // Click the button to trigger Turbo
    button.click()
  }

  showLoadingState() {
    if (!this.hasLoadButtonTarget) return
    
    const button = this.loadButtonTarget.querySelector('a')
    if (button) {
      button.classList.add('opacity-75', 'cursor-wait')
      button.innerHTML = `
        <i class="fas fa-spinner fa-spin mr-2"></i>
        Loading More Posts...
      `
    }
  }

  // Called after Turbo Stream completes to restart observing
  turbo_stream_render() {
    console.log('📡 Turbo stream rendered, restarting observation')
    
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      if (this.hasLoadButtonTarget && this.autoLoadValue) {
        this.startObserving()
      }
    }, 100)
  }
  
  // Also handle turbo:frame-load event for better compatibility
  turboFrameLoad() {
    console.log('🖼️ Turbo frame loaded, restarting observation')
    
    setTimeout(() => {
      if (this.hasLoadButtonTarget && this.autoLoadValue) {
        this.startObserving()
      }
    }, 100)
  }
}